import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { LoadingService } from '../../services/loading.service';
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { FlagService } from '../../shared/services/flag.service';
import { FlagType } from '../../shared/utils/enums';
import { AuthService } from "../../services/auth.service";
import { environment } from '../../../environments/environment';

export const functionalInterceptor: HttpInterceptorFn = (req, next) => {
  const flag = inject(FlagService);
  const auth = inject(AuthService);

  // Only our own backend gets the JWT — external APIs (Photon, geo.api.gouv.fr, nominatim…)
  // must never receive the session token, and their 401/403 must NOT be treated as an
  // expired Collary session. BASE_URL_NOTIF ("…/api") is the broader base and covers both
  // it and BASE_URL ("…/api/api"), so all our backend calls are matched.
  const isApiCall = req.url.startsWith(environment.api.BASE_URL_NOTIF);

  const authReq = isApiCall
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
    : req;

  // Public auth endpoints: a 401 here means bad credentials, not an expired session.
  const isAuthCall =
    req.url.includes('/auth/sign_in') ||
    req.url.includes('/auth/sign_up') ||
    req.url.includes('/auth/onboard') ||
    req.url.includes('/auth/check_verification_code') ||
    req.url.includes('/password/forgot');

  return next(authReq).pipe(
    tap((event) => {}),
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        // Not authenticated / token expired → log out and redirect to login.
        if (isApiCall && (err.status === 401 || err.status === 403)) {
          if (isAuthCall) {
            flag.displayFlag('Non autorisé !', FlagType.error);
          } else if (auth.user) {
            flag.displayFlag('Session expirée, veuillez vous reconnecter.', FlagType.error);
            auth.disconnect(); // clears the session, navigates to /login, reloads
          }
        } else if (err.status !== 200) {
          flag.displayFlag('Une erreur est survenue !', FlagType.error);
        }
      } else {
        // Handle non-HTTP errors
        flag.displayFlag('Une erreur est survenue !', FlagType.error);
      }

      // Re-throw the error to propagate it further
      return throwError(() => err);
    })
  );
};

// Loading Spinner Interceptor
export const loadingSpinnerInterceptorFunctional: HttpInterceptorFn = (
  req,
  next
) => {
  const loadingService = inject(LoadingService); // Instantiate the loading service

  // loadingService.toggleLoading(true); // Show loading spinner UI element
  setTimeout(() => {
    loadingService.toggleLoading(true);
  }, 0);
  return next(req).pipe(
    finalize(() => {
      // Hide loading spinner UI element
      setTimeout(() => {
        loadingService.toggleLoading(false);
      }, 700);
    })
  );
};
